module.exports = __webpack_public_path__ + "column-sort.f2005ea043059573f4aa4b8c758a16c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/column-sort.svg
// module id = 1132
// module chunks = 0